<template>
  <section class="bg-white py-14">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div
        class="flex flex-col items-start justify-between gap-7 rounded-3xl bg-gradient-to-r from-[#062b62] to-[#0b4a9c] px-7 py-9 text-white md:flex-row md:items-center md:px-10"
      >
        <div>
          <p
            class="text-xs font-black uppercase tracking-[0.14em] text-blue-200"
          >
            Precisa de ajuda?
          </p>

          <h2 class="mt-2 text-2xl font-black md:text-3xl">
            Fale com um especialista antes de comprar
          </h2>

          <p class="mt-2 max-w-2xl text-sm leading-6 text-blue-100">
            Tire dúvidas sobre versão, compatibilidade, modalidade de licença e
            instalação.
          </p>
        </div>

        <a
          :href="whatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex min-h-12 shrink-0 items-center justify-center rounded-xl bg-white px-6 py-3 text-sm font-black text-blue-800 transition hover:-translate-y-0.5 hover:bg-blue-50"
        >
          Conversar no WhatsApp
        </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const whatsappUrl =
  "https://wa.me/5511910512647?text=" +
  encodeURIComponent(
    "Olá! Preciso de ajuda para escolher uma licença de software.",
  );
</script>
